// RFC 5545 §3.3.11: backslash must be escaped first, or the escapes added
// for `;` and `,` would themselves get escaped on the next pass.
const escapeIcsText = (text) => text.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,');
const formatIcsDate = (date) => {
    const year = date.getUTCFullYear();
    const month = `${date.getUTCMonth() + 1}`.padStart(2, '0');
    const day = `${date.getUTCDate()}`.padStart(2, '0');
    return `${year}${month}${day}`;
};
export const buildIcsContent = (event) => {
    const dtstamp = `${formatIcsDate(new Date())}T000000Z`;
    const uid = `${dtstamp}-${Math.random().toString(36).slice(2)}@tinyhealth.com`;
    const lines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Tiny Health//Calendar Event//EN',
        'BEGIN:VEVENT',
        `UID:${uid}`,
        `DTSTAMP:${dtstamp}`,
        `DTSTART;VALUE=DATE:${formatIcsDate(event.date)}`,
        `SUMMARY:${escapeIcsText(event.title)}`,
        ...(event.description
            ? [`DESCRIPTION:${escapeIcsText(event.description)}`]
            : []),
        'END:VEVENT',
        'END:VCALENDAR',
    ];
    return lines.join('\r\n') + '\r\n';
};
export const downloadIcsEvent = (event) => {
    const icsContent = buildIcsContent(event);
    const blob = new Blob([icsContent], { type: 'text/calendar' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'retest-reminder.ics';
    anchor.click();
    setTimeout(() => URL.revokeObjectURL(url), 0);
};
//# sourceMappingURL=createCalendarEvent.js.map